var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconErrorWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F75676",
    d: "M8.923 8.58H7.608V5.95h1.315m0 5.259H7.608V9.894h1.315m-6.5 3.287h11.686c.442 0 .8-.358.8-.8 0-.14-.037-.279-.107-.4L8.958 1.886c-.221-.383-.71-.513-1.093-.292-.121.07-.222.17-.292.292L1.73 11.98c-.222.383-.091.872.291 1.093.122.07.26.108.401.108z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErrorWhite);
export default __webpack_public_path__ + "static/media/icon_error_white.0375b0a524ac7696253d841607612aaa.svg";
export { ForwardRef as ReactComponent };